module.exports = __webpack_public_path__ + "static/fonts/NeoSansPro-BoldItalic.82d9c1d.eot";